import { render, staticRenderFns } from "./AuthTemplate.vue?vue&type=template&id=187b72a8&"
var script = {}
import style0 from "./AuthTemplate.vue?vue&type=style&index=0&id=187b72a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports